import {
    Component,
    ComponentConstructor,
    Object3D,
    Component as WLEComponent,
} from '@wonderlandengine/api';
import {Container, Text} from '@wonderlandengine/react-ui/components';
import React, {
    forwardRef,
    Component as ReactComponent,
    useEffect,
    useImperativeHandle,
    useLayoutEffect,
    useRef,
} from 'react';
import {Tween} from '@wonderlandengine/tweenjs';
import {ReactUiBase} from '@wonderlandengine/react-ui';

// // Define a custom hook or utility to control and batch updates
// function useControlledUpdates(updateFn, dependencies) {
//     // Use React's useRef or similar to hold mutable values without causing re-renders
//     // const updateRef = React.useRef(updateFn);

//     // Effect to update the function reference if the function or dependencies change
//     React.useEffect(() => {
//         //   updateRef.current = updateFn;
//     }, [updateFn, ...dependencies]);

//     return (args) => {
//         // Call the current update function with arguments
//         // updateRef.current(args);
//     };
// }

export class WLERTest extends React.Component {
    render(): React.ReactNode {
        return (
            <Container>
                <Text>Hello World</Text>
            </Container>
        );
    }
}

export const WLEReactComponent = forwardRef<Component, {}>((props, ref) => {
    const o3d = useRef<Object3D>(null);
    const wlReactComp = useRef<WLReactComp>(null);
    // const wlc = React.createElement<React.RefAttributes<Object3D>>('wonderland-component', {
    //     ref: o3d,
    // });

    useLayoutEffect(() => {
        const pos = o3d.current.getPositionLocal();
        const sc = o3d.current.getScalingLocal();
        console.log('testRef', pos, sc);
        console.log('testRef', props);
        // console.log(testRef.current.getBoundingClientRect());
    }, []);
    // useEffect(() => {
    //     if (o3d.current) {
    //         // Add the component to the 3D object if not already added
    //         wlReactComp.current = o3d.current.addComponent(WLReactComp);
    //     }
    //     return () => {
    //         wlReactComp.current.destroy();
    //     };
    // }, []);
    return <Container ref={o3d}></Container>;
});

export class WLReactComp extends WLEComponent {
    static TypeName = 'wl-react-comp';

    start(): void {
        console.log('WLReactComp start', this.object.getPositionLocal());
    }
    first = 0;

    update(delta: number): void {
        if (this.first < 1) {
            console.log('WLReactComp update', this.object.getPositionLocal());
            this.first++;
        }
    }
    // reactCompWrapper: ReactCompWrapper;
    // start(): void {
    //     this.reactCompWrapper = null;
    // }
    // componentDidMount() {
    //     // Add the React component wrapper to the Wonderland component
    //     //this.reactCompWrapper = this.object.addComponent(ReactCompWrapper);
    // }
    // update(dt) {
    //     // Optimize updates and prevent unnecessary re-renders
    //     if (dt > 0.1 && this.reactCompWrapper) {
    //         this.reactCompWrapper.updateState({longDelta: true});
    //     }
    // }
    // componentWillUnmount() {
    //     // Remove the React component when the Wonderland component is unmounted
    //     if (this.reactCompWrapper) {
    //         // this.object.removeComponent(this.reactCompWrapper);
    //         this.reactCompWrapper = null;
    //     }
    // }
}
